<template>
  <div>
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <h2>公海资源记录导出</h2>
            <div
              class="input-area none-month"
              @keyup.enter="inputAreaKeyup">
              <div class="box-content" >
                <label class="form-tit">客户编码</label>
                <el-input v-model.trim="searchData.name" class="jm-input220"/>
              </div>
              <div class="box-content" >
                <label class="form-tit">进入前顾问</label>
                <el-select
                  v-model="searchData.crm_before_sayer"
                  filterable
                  class="jm-input220"
                  clearable
                  placeholder="请选择">
                  <el-option-group
                    v-for="(group, k) in ds.advisory_teacher"
                    :key="k"
                    :label="k">
                    <el-option
                      v-for="item in group"
                      :key="`${item.country}_${item.userid}`"
                      :label="item.truename"
                      :value="item.userid"/>
                  </el-option-group>
                </el-select>
              </div>
              <div class="box-content" >
                <label class="form-tit">分配顾问</label>
                <el-select
                  v-model="searchData.crm_sayer"
                  filterable
                  class="jm-input220"
                  clearable
                  placeholder="请选择">
                  <el-option-group
                    v-for="(group, k) in ds.advisory_teacher"
                    :key="k"
                    :label="k">
                    <el-option
                      v-for="item in group"
                      :key="`${item.country}_${item.userid}`"
                      :label="item.truename"
                      :value="item.userid"/>
                  </el-option-group>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">进入公海时间</label>
                <el-date-picker
                  class="jm-input135"
                  v-model="searchData.returnStart"
                  type="month"
                  format='yyyy-MM'
                  value-format='yyyy-MM'
                  placeholder="选择月"/>
                <i>-</i>
                <el-date-picker
                  class="jm-input135"
                  v-model="searchData.returnEnd"
                  type="month"
                  format='yyyy-MM'
                  value-format='yyyy-MM'
                  placeholder="选择月"/>
              </div>
              <div class="box-content">
                <label class="form-tit">分配时间</label>
                <el-date-picker
                  class="jm-input135"
                  v-model="searchData.pickUpStart"
                  type="month"
                  format='yyyy-MM'
                  value-format='yyyy-MM'
                  placeholder="选择月"/>
                <i>-</i>
                <el-date-picker
                  class="jm-input135"
                  v-model="searchData.pickUpEnd"
                  type="month"
                  format='yyyy-MM'
                  value-format='yyyy-MM'
                  placeholder="选择月"/>
              </div>
              <div class="box-content">
                <label class="form-tit">进入规则</label>
                <el-select
                  class="jm-input220"
                  clearable
                  v-model="searchData.rule"
                  placeholder="请选择">
                  <el-option v-for="rule in ds.international_waters_rule" :key="rule.key" :label="rule.name" :title="rule.intro" :value="rule.id"/>
                </el-select>
              </div>
              <div class="jm-primary">
                <el-button type="primary" :disabled="!canSearch" @click="doSearch">筛选</el-button>
                <el-button type="default" @click="resetSearchData">重置</el-button>
                <el-button type="success" :disabled="this.export === null" @click="exportVisit">导出</el-button>
                <span>共<i>{{ num }}</i>条</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import toolbar from '@/components/tool/toolbar.vue';
import { jmAreaselect, jmChannel, jmEducationSelect, jmDictSelect } from '@/components/tool';
import tableList from '@/components/data/tableList.vue';
import { formatSelectGroupData } from '@/utils/utils.js';

let data = {};
const exData = {
  num: 0,
  exporting: false,
  batch: []
};
  // 数据源
data.ds = {
  advisory_teacher: null,
  international_waters_rule: null,
};
/*
   * v-model 数据源
   * */
data.searchData = {
  name: '', // 客户编码
  crm_sayer: '', // 领衔顾问
  crm_before_sayer: '', // 进入前顾问
  returnStart: '', // 回访时间
  returnEnd: '', // 回访时间
  pickUpStart: '', // 捞取时间
  pickUpEnd: '', // 捞取时间
  rule: '', // 进入前规则
};
data.export = null;
data = Object.assign(data, exData);
export default {
  data() {
    return data;
  },
  components: {
    'jm-toolbar': toolbar,
    jmAreaselect,
    jmChannel,
    jmEducationSelect,
    jmDictSelect,
    'jm-tableList': tableList,
  },
  methods: {
    getTea() {
      this.$http._post({
        url: '/index/student/searchDs',
      }).then(({ data }) => {
        this.ds.advisory_teacher = formatSelectGroupData(data.advisory_teacher);
        this.ds.international_waters_rule = data.international_waters_rule;
      }).catch(() => {
        this.$message.error('网络错误');
      });
    },
    doSearch() {
      //  请求
      this.$http._post({
        url: '/index/International_waters/excelCount',
        data: this.searchData,
      }).then(({ data }) => {
        this.export = Object.assign({}, this.searchData);
        this.num = data;
      }).catch(() => {
        this.$message.error('网络错误');
      });
    },
    /*
       * 清空自定义搜索条件
       * */
    resetSearchData() {
      Object.keys(this.searchData).forEach((key) => {
        if (typeof this.searchData[key] !== 'object') {
          this.searchData[key] = '';
        }
        this.num = 0;
      });
    },
    exportVisit() {
      this.$confirm(`此操作将领取${this.num}条, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.exporting = true;
        this.$http._post({
          url: '/index/International_waters/excelInternationalWaters',
          data: this.export,
        }).then(({ data }) => {
          this.exporting = false;
          this.$http._download({
            filename: data,
            download: '公海资源记录.xlsx'
          });
        }).catch(() => {
          this.$message.error('可能数据太多了。。。');
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
  },
  mounted() {
    this.getTea();
  },
  watch: {
  },
  computed: {
    canSearch() {
      return Object.values(this.searchData).some((value) => {
        if (value === null) {
          return false;
        }

        if (typeof value === 'string' && value !== '') {
          return true;
        }

        if (Array.isArray(value)) {
          return value.length && value[0];
        }

        if (value === true) {
          return true;
        }

        if (typeof value === 'object') {
          let temp = Object.values(value);
          return temp.length && temp[0];
        }

        if (value) {
          return true;
        }
        return false;
      });
    },
  },
  // mixins: [student],
};
</script>
<style scoped>
 .jm-primary>span{
     margin-left: 16px;
     font-weight: 600;
     font-size: 16px;
 }
</style>
